import socket from '@/plugins/socket'
import GameStatus from '@/store/model/sport/sport/GameStatus'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas.forEach(item => { state.list.push(new GameStatus(item)) })
    }
  },
  actions: {
    init (state) { socket.get('SportSportGamestatus', 'Sport/GameStatus/set') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => { return state.list.find((item) => { return item.id === id }) }
  }
}
